var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5617 17.9435H20.7797L20.8545 17.7388L23.0794 11.6489H35.6884V18.0565H23.4903H23.2726L23.1977 18.2609L20.9667 24.3511H0.311634V17.9435H20.5617ZM35.6884 6.83458L0.311634 6.82846V0.311634H35.6884V6.83458ZM0.311634 29.1654H35.6884V35.6883L0.311634 35.6822V29.1654Z",
    fill: "url(#paint0_linear_554_1359)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5617 17.9435H20.7797L20.8545 17.7388L23.0794 11.6489H35.6884V18.0565H23.4903H23.2726L23.1977 18.2609L20.9667 24.3511H0.311634V17.9435H20.5617ZM35.6884 6.83458L0.311634 6.82846V0.311634H35.6884V6.83458ZM0.311634 29.1654H35.6884V35.6883L0.311634 35.6822V29.1654Z",
    stroke: "url(#paint1_linear_554_1359)",
    strokeWidth: 0.623269,
    style: {
      mixBlendMode: "plus-lighter"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1359",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_1359",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadreIcon);
export default __webpack_public_path__ + "static/media/padre-icon.e2c87f2f491e4c6fb4bfc7b36c50ca04.svg";
export { ForwardRef as ReactComponent };